export const GET_LIST_COUNTRY = 'GET_LIST_COUNTRY'
export const GET_LIST_COUNTRY_SUCCESS = 'GET_LIST_COUNTRY_SUCCESS'
export const SEARCH_COUNTRY = 'SEARCH_COUNTRY'

export const getListCountrySuccess = (payload) => {
    return {
        type: GET_LIST_COUNTRY_SUCCESS,
        payload
    }
}

export const getListCountry = (payload) => {
    return {
        type: GET_LIST_COUNTRY,
        payload
    }
}

export const searchCountry = (payload) => {
    return {
        type: SEARCH_COUNTRY,
        payload
    }
}



// WEBPACK FOOTER //
// ./src/actions/getListCountry.js